import { render, staticRenderFns } from "./AppSvgIcon.vue?vue&type=template&id=a45aa9fc"
import script from "./AppSvgIcon.vue?vue&type=script&lang=js"
export * from "./AppSvgIcon.vue?vue&type=script&lang=js"
import style0 from "./AppSvgIcon.vue?vue&type=style&index=0&id=a45aa9fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports